import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";

const Filters = ({ setFilters, filters }) => {
    const { agentAbsenceReason } = useReportFiltersFetch({ fetchAgentAbsenceReason: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <SelectComponent
                        label="Motivo"
                        isMulti={true}
                        options={agentAbsenceReason}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                        classNameWrapper="w-full"
                    />

                    <AccessForm filters={filters} setFilters={setFilters} valueAsId={true}/>

                </form>
            </div>
        </>
    );
};

export default Filters;